<template>
  <div class="pdfContainer">
    <loading
      :active.sync="loading"
      :is-full-page="fullpage"
      :height="80"
      :width="80"
    ></loading>
    <div style="height: 100vh;" id="iframewrapper"></div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import queryString from 'query-string';

export default {
  name: 'Player',
  data() {
    return {
      redirect_url: undefined,
      jsonData: undefined,
      pdfURL: undefined,
      loading: false,
      fullpage: true,
    };
  },
  components: {
    Loading,
  },

  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const { test_code, pdf_type } = searchParams;
    this.loading = true;
    axios
      .get(
        `https://portal.ourbethel.cn/api/base/dreamit/auto/info?test_code=${test_code}`
      )
      .then((res) => {
        axios
          .post(
            'https://pdf.ourbethel.cn/report1',
            {
              ...res.data.data.report,
              long_objectives: res.data.data.long_objectives,
              nonstandard_complaint: res.data.data.nonstandard_complaint,
              intervention_assessment_summary:
                res.data.data.intervention_assessment_summary,
              pdf_type,
            },
            {
              responseType: 'blob',
            }
          )
          .then((response) => {
            let blob = new Blob([response.data], { type: 'application/pdf' });
            const url2 = window.URL.createObjectURL(blob);

            console.log(response, url2);
            const iframeWrapper = document.querySelector('#iframewrapper');

            if (this.isMobileDevice()) {
              window.location.replace(url2);
            } else {
              this.createIframe(iframeWrapper, url2);
            }
            this.loading = false;
          })
          .catch((err) => {
            console.log('-----err', err);
            this.loading = false;
          });
      })
      .catch((pError) => {
        console.log('-----err', pError);
        this.loading = false;
      });
  },

  methods: {
    isMobileDevice() {
      var userAgent =
        navigator.platform ||
        navigator.userAgent ||
        navigator.vendor ||
        window.opera;

      if (/windows phone/i.test(userAgent)) {
        return true;
      }

      if (/android/i.test(userAgent)) {
        return true;
      }
      if (
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      ) {
        return true;
      }
      return false;
    },
    createIframe(dom, src, onload) {
      //在document中创建iframe
      var iframe = document.createElement('iframe');

      //设置iframe的样式
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.margin = '0';
      iframe.style.padding = '0';
      iframe.style.overflow = 'hidden';
      iframe.style.border = 'none';

      //绑定iframe的onload事件,处理事件的兼容问题
      if (
        onload &&
        Object.prototype.toString.call(onload) === '[object Function]'
      ) {
        if (iframe.attachEvent) {
          iframe.attachEvent('onload', onload);
        } else if (iframe.addEventListener) {
          iframe.addEventListener('load', onload);
        } else {
          iframe.onload = onload;
        }
      }

      iframe.src = src;
      //把iframe载入到dom以下
      dom.appendChild(iframe);
      return iframe;
    },
  },
};
</script>

<style scoped>
.pdfContainer {
  position: fixed;
  z-index: 10000;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.button {
  width: 200px;
  height: 45px;
  margin-bottom: 50px;
}

.button-ctn {
  display: flex;
  text-align: justify;
  flex-wrap: wrap;
}

.link-ctn {
  background-color: red;
  max-width: 80vw;
}

.url {
  display: flex;
  max-width: 80%;
  text-align: justify;
  word-wrap: break-word;
}

.pdf {
  width: 100%;
  height: auto;
}
</style>
